<template>
    <div v-loading="loading">
        <el-tabs type="border-card" v-model="tabName">
            <el-tab-pane :label="$t('lang.smartsms.configuration')" name="0">
                <SmsOption @refesh="refesh" :hardware_class="hardware_class" ref="option" @save="saveOption"></SmsOption>
            </el-tab-pane>
            <el-tab-pane :label="$t('lang.smartsms.inbox')" name="1">
                <Inbox @refesh="refesh" @removeInboxMsg="removeInboxMsg" ref="inbox"></Inbox>
            </el-tab-pane>
            <el-tab-pane :label="$t('lang.smartsms.outbox')" name="2">
                <Outbox ref="outbox" @deleteOutboxMsg="deleteOutboxMsg" @sendSelectSms="sendSelectSms"
                    @saveAsDraft="saveAsDraft" :maks="outboxMask" @refesh="refesh">
                </Outbox>
            </el-tab-pane>
            <el-tab-pane :label="$t('lang.smartsms.advanced')" name="3">
                <Advanced @downloadLog="downloadLog" @saveAdvanced="saveAdvanced" @refesh="refesh" ref="advanced">
                </Advanced>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import SmsOption from "./components/SmsOption.vue";
import Inbox from "./components/Inbox.vue";
import Outbox from "./components/Outbox.vue";
import Advanced from "./components/Advanced.vue";
import { listConfig, updateConfig, getLog } from "@/api/configurationlist";
export default {
    name: "",
    components: {
        SmsOption,
        Inbox,
        Outbox,
        Advanced
    },
    props: ['deviceSn', 'deviceDid'],
    data() {
        return {
            tabName: "0",//0=>配置，1=>收件箱,2=>发件箱,3=>高级
            loading: true,
            outboxMask: "",
            overMask: "",
            hardware_class: "",
            inboxMask: "",
        };
    },
    methods: {
        // 获取配置
        async getConfig() {
            const res = await listConfig(this.deviceSn, this.deviceDid, [
                {
                    config: "smartsms",
                    section: "setting",
                    options: [
                        {
                            option: 'modem'
                        },
                        {
                            option: 'phone1'
                        },
                        {
                            option: 'memory'
                        },
                        {
                            option: 'center'
                        },
                        {
                            option: 'validity'
                        },
                        {
                            option: 'interval'
                        },
                        {
                            option: 'del_up_thr'
                        },
                        {
                            option: 'automatic_del'
                        },
                        {
                            option: 'del_low_thr'
                        },
                        {
                            option: 'delinterval'
                        }
                    ],
                    lists: [
                        {
                            list: 'whitelist'
                        }
                    ]
                },
                {
                    config: "inbox",
                    section: "status",
                    options: [
                        {
                            option: "total"
                        },
                        {
                            option: "used"
                        },
                        {
                            option: "simcard"
                        },
                        {
                            option: "mask0"
                        },
                        {
                            option: "mask1"
                        },
                        {
                            option: "mask2"
                        },
                        {
                            option: "mask3"
                        },
                        {
                            option: "mask4"
                        },
                        {
                            option: "mask5"
                        },
                        {
                            option: "mask6"
                        },
                        {
                            option: "mask7"
                        },
                    ]
                },
                {
                    config: "inbox",
                    section: "msg",
                    options: [
                        {
                            option: "index"
                        },
                        {
                            option: "phone"
                        },
                        {
                            option: "content"
                        },
                        {
                            option: "date"
                        },
                        {
                            option: "state"
                        },
                        {
                            option: "merged"
                        },
                    ]
                },
                {
                    config: "outbox",
                    section: "status",
                    options: [
                        {
                            option: "total",
                        },
                        {
                            option: "mask0",
                        },
                        {
                            option: "mask1",
                        }
                    ]
                },
                {
                    config: "outbox",
                    section: "msg",
                    options: [
                        {
                            option: "index"
                        },
                        {
                            option: "phone"
                        },
                        {
                            option: "content"
                        },
                        {
                            option: "date"
                        },
                        {
                            option: "state"
                        },
                    ]
                },
                {
                    config: "smartsms",
                    section: "service",
                    options: [
                        {
                            option: 'enabled'
                        },
                        {
                            option: 'enable_debug'
                        },
                        {
                            option: 'log_file_num'
                        },
                        {
                            option: 'log_file_size'
                        },
                        {
                            option: 'log_priority'
                        },
                    ],
                },
                {
                    config: "ciot",
                    section: 'system',
                    options: [
                        {
                            option: "hardware_class"
                        }
                    ]
                },
            ]);
            if (res.data.code === 0) {
                let options = res.data.data.mess[0].s_objects;
                let inboxStatus = res.data.data.mess[1].s_objects;
                let inboxList = res.data.data.mess[2].s_objects;
                let outboxStatus = res.data.data.mess[3].s_objects;
                let outboxList = res.data.data.mess[4].s_objects;
                let serviceOptions = res.data.data.mess[5].s_objects;
                this.hardware_class = res.data.data.mess[6].s_objects[0].options.hardware_class;

                if (options[0].lists.whitelist.length === 0) {
                    options[0].lists.whitelist.push('')
                }
                options[0].options.whitelist = options[0].lists.whitelist;
                options[0].options.automatic_del === '1' ? options[0].options.automatic_del = true : options[0].options.automatic_del = false
                this.$refs['option'].option = options[0].options;


                inboxList = inboxList.map(item => {
                    return item.options
                })
                this.$refs['inbox'].total = inboxStatus[0].options.total
                this.$refs['inbox'].used = inboxStatus[0].options.used
                this.$refs['inbox'].simcard = inboxStatus[0].options.simcard
                this.$refs['inbox'].list = inboxList

                let inboxMask0 = Number(inboxStatus[0].options.mask0).toString(2).split('').reverse().join('')
                let inboxMask1 = Number(inboxStatus[0].options.mask1).toString(2).split('').reverse().join('')
                let inboxMask2 = Number(inboxStatus[0].options.mask2).toString(2).split('').reverse().join('')
                let inboxMask3 = Number(inboxStatus[0].options.mask3).toString(2).split('').reverse().join('')
                let inboxMask4 = Number(inboxStatus[0].options.mask4).toString(2).split('').reverse().join('')
                let inboxMask5 = Number(inboxStatus[0].options.mask5).toString(2).split('').reverse().join('')
                let inboxMask6 = Number(inboxStatus[0].options.mask6).toString(2).split('').reverse().join('')
                let inboxMask7 = Number(inboxStatus[0].options.mask7).toString(2).split('').reverse().join('')

                inboxMask0 = this.addZero(inboxMask0)
                inboxMask1 = this.addZero(inboxMask1)
                inboxMask2 = this.addZero(inboxMask2)
                inboxMask3 = this.addZero(inboxMask3)
                inboxMask4 = this.addZero(inboxMask4)
                inboxMask5 = this.addZero(inboxMask5)
                inboxMask6 = this.addZero(inboxMask6)
                inboxMask7 = this.addZero(inboxMask7)
                this.inboxMask = inboxMask0 + inboxMask1 + inboxMask2 + inboxMask3 + inboxMask4 + inboxMask5 + inboxMask6 + inboxMask7
                outboxList = outboxList.map(item => {
                    return {
                        ...item.options,
                        meta_index: item.index
                    }
                })
                this.$refs['outbox'].total = outboxStatus[0].options.total
                this.$refs['outbox'].used = outboxList.length

                let outBefore = Number(outboxStatus[0].options.mask0).toString(2).split('').reverse().join('')
                let outAfter = Number(outboxStatus[0].options.mask1).toString(2).split('').reverse().join('')
                outBefore = this.addZero(outBefore)
                outAfter = this.addZero(outAfter)
                this.outboxMask = outBefore + outAfter
                this.$refs['outbox'].list = outboxList.sort((a, b) => {
                    return a.index - b.index
                }).map(item => {
                    return {
                        ...item,
                        mask: this.outboxMask[item.index]
                    }
                })

                serviceOptions[0].options.enabled = serviceOptions[0].options.enabled === '1' ? true : false
                serviceOptions[0].options.enable_debug = serviceOptions[0].options.enable_debug === '1' ? true : false
                this.$refs['advanced'].options = serviceOptions[0].options
            } else {
                this.$message.error("获取失败");
            }
        },
        async saveOption(e) {
            this.loading = true;
            console.log(e);
            await updateConfig(this.deviceSn, this.deviceDid, [
                {
                    config: "smartsms",
                    section: "setting",
                    action: 0,
                    index: [0],
                    options: e.options,
                    lists: e.lists
                }
            ]).then(res => {
            })
            await this.getConfig()
            this.loading = false
        },
        // 补0方法
        addZero(value) {
            if (value.length < 32) {
                value = value + '0'.repeat(32 - value.length)
            }
            return value
        },
        async removeInboxMsg(e) {
            this.loading = true
            let inboxMask = this.inboxMask.split('')
            inboxMask[e.index] = '0'
            let inboxMask0 = parseInt(inboxMask.slice(0, 32).reverse().join(''), 2).toString()
            let inboxMask1 = parseInt(inboxMask.slice(32, 64).reverse().join(''), 2).toString()
            let inboxMask2 = parseInt(inboxMask.slice(64, 96).reverse().join(''), 2).toString()
            let inboxMask3 = parseInt(inboxMask.slice(96, 128).reverse().join(''), 2).toString()
            let inboxMask4 = parseInt(inboxMask.slice(128, 160).reverse().join(''), 2).toString()
            let inboxMask5 = parseInt(inboxMask.slice(160, 192).reverse().join(''), 2).toString()
            let inboxMask6 = parseInt(inboxMask.slice(192, 224).reverse().join(''), 2).toString()
            let inboxMask7 = parseInt(inboxMask.slice(224, 256).reverse().join(''), 2).toString()

            await updateConfig(this.deviceSn, this.deviceDid, [
                {
                    config: "inbox",
                    section: "msg",
                    action: 2,
                    index: [Number(e.iindex)],
                },
                {
                    config: "inbox",
                    section: "status",
                    action: 0,
                    index: [0],
                    options: {
                        mask0: inboxMask0,
                        mask1: inboxMask1,
                        mask2: inboxMask2,
                        mask3: inboxMask3,
                        mask4: inboxMask4,
                        mask5: inboxMask5,
                        mask6: inboxMask6,
                        mask7: inboxMask7,
                    }
                }
            ]).then(res => { })
            await this.getConfig()
            this.loading = false
        },
        async saveAsDraft(e) {
            this.loading = true
            let new_index = this.$refs['outbox'].list.length
            if (e.index == "") {
                for (let i = 0; i < 50; i++) {
                    if (this.$refs['outbox'].list.find(v => v.index == i)) {

                    } else {
                        new_index = i
                        break
                    }
                }
                let m = this.outboxMask.split('');
                if (e.state == 5) {
                    m[new_index] = '0'
                } else {
                    m[new_index] = '1'
                }
                this.outboxMask = m.join('');
                // 新增
                await updateConfig(this.deviceSn, this.deviceDid, [
                    {
                        config: "outbox",
                        section: "msg",
                        sname: "id" + new_index,
                        action: 1,
                        index: [new_index],
                        options: {
                            phone: e.phone,
                            content: e.content,
                            date: Date.now().toString(),
                            state: e.state,
                            index: new_index
                        }
                    },
                    {
                        config: "outbox",
                        section: "status",
                        action: 0,
                        index: [0],
                        options: {
                            mask0: parseInt(this.outboxMask.slice(0, 32).split('').reverse().join(''), 2).toString(),
                            // 取outboxMask的第32位到第63位，并且转为十进制
                            mask1: parseInt(this.outboxMask.slice(32, 64).split('').reverse().join(''), 2).toString()
                        }
                    }
                ]).then(async res => {
                    if (res.data.data.mess === 0) {
                        this.$message.success("存为草稿成功");
                    } else {
                        this.$message.error("存为草稿失败");
                    }
                    await this.getConfig()
                    this.loading = false
                    this.$refs.outbox.editMsgDialog = false
                })
            } else {
                await updateConfig(this.deviceSn, this.deviceDid, [
                    {
                        config: "outbox",
                        section: "msg",
                        action: 0,
                        index: [Number(e.index)],
                        options: {
                            phone: e.phone,
                            content: e.content,
                            date: Date.now().toString(),
                            state: e.state
                        }
                    }
                ]).then(async res => {

                    if (res.data.data.mess === 0) {
                        this.$message.success("短信发送中");
                    } else {
                        this.$message.error("短信发送失败");
                    }
                    await this.getConfig()
                    this.loading = false
                    this.$refs.outbox.editMsgDialog = false
                })
                await this.getConfig()
                this.loading = false
                this.$refs.outbox.editMsgDialog = false
            }
        },
        async saveAdvanced(e) {
            this.loading = true
            await updateConfig(this.deviceSn, this.deviceDid, [
                {
                    config: "smartsms",
                    section: "service",
                    server: "smartsms",
                    action: 0,
                    index: [0],
                    options: e,
                }
            ]).then(res => { })
            await this.getConfig()
            this.loading = false
        },
        async deleteOutboxMsg(e) {
            // 将this.outboxMask的第e.index位设置为0
            let m = this.outboxMask.split('');
            m[e.index] = '0'
            this.outboxMask = m.join('');
            this.loading = true;
            await updateConfig(this.deviceSn, this.deviceDid, [
                {
                    config: "outbox",
                    section: "msg",
                    action: 2,
                    index: [Number(e.iindex)],
                },
                {
                    config: "outbox",
                    section: "status",
                    action: 0,
                    index: [0],
                    options: {
                        mask0: parseInt(this.outboxMask.slice(0, 32).split('').reverse().join(''), 2).toString(),
                        // 取outboxMask的第32位到第63位，并且转为十进制
                        mask1: parseInt(this.outboxMask.slice(32, 64).split('').reverse().join(''), 2).toString()
                    }
                }
            ]).then(res => { })
            await this.getConfig()
            this.loading = false
        },
        downloadLog() {
            let params = {
                did: this.deviceDid,
                sn: this.deviceSn,
                mess: "smartsms"
            }
            getLog(params).then(res => {
                let blob = new Blob([res.data], { type: 'application/octet-stream' });
                let fileName = 'log.txt';
                if ('download' in document.createElement('a')) { // 非IE下载
                    let elink = document.createElement('a');
                    elink.download = fileName;
                    elink.style.display = 'none';
                    elink.href = URL.createObjectURL(blob);
                    document.body.appendChild(elink);
                    elink.click();
                    URL.revokeObjectURL(elink.href); // 释放URL 对象
                    document.body.removeChild(elink);
                } else { // IE10+下载
                    navigator.msSaveBlob(blob, fileName);
                }
            });
        },
        sendSelectSms(e) {
            let m = this.outboxMask.split('');
            m[e.index] = '1'
            this.outboxMask = m.join('');
            this.loading = true;
            updateConfig(this.deviceSn, this.deviceDid, [
                {
                    config: "outbox",
                    section: "msg",
                    action: 0,
                    index: [Number(e.iindex)],
                    options: {
                        state: "2"
                    }
                },
                {
                    config: "outbox",
                    section: "status",
                    action: 0,
                    index: [0],
                    options: {
                        mask0: parseInt(this.outboxMask.slice(0, 32).split('').reverse().join(''), 2).toString(),
                        // 取outboxMask的第32位到第63位，并且转为十进制
                        mask1: parseInt(this.outboxMask.slice(32, 64).split('').reverse().join(''), 2).toString()
                    }
                }
            ]).then(res => {
                if (res.data.data.mess === 0) {
                    this.$message.success("短信发送中");
                    this.loading = false;
                    this.$refs.outbox.editMsgDialog = false

                } else {
                    this.$message.error("短信发送失败");
                    this.loading = false;
                    this.$refs.outbox.editMsgDialog = false
                }
            })
        },
        async refesh() {
            this.loading = true
            await this.getConfig()
            this.loading = false
        },
    },
    async mounted() {
        await this.getConfig()
        this.loading = false
    },
};
</script>
<style scoped></style>
